import PropTypes from "prop-types";

import { alignItems, colors } from "../../consts";
import { t } from "../../services";

import FlexContainers from "../Containers/FlexContainers";
import WrapperContainer from "../Containers/WrapperContainer";
import { Paragraph2 } from "../Text/Paragraphs";

import { Line, StepContentWrapper, StepHeader, StepNumber, StepStyled, StepTitle } from "./styled";
import { SVG } from "../index";

export const Step = ({ step, title, DividerContent, isActive, isDisabled, setActiveStep }) => {
  return (
    <StepStyled
      Container={FlexContainers.FlexColumnStart}
      alignItems={alignItems.start}
      isActive={isActive}
      isDisabled={isDisabled}>
      <StepHeader
        Container={FlexContainers.FlexRowStart}
        gap={8}
        isClickable={!isDisabled}
        onClick={!isDisabled ? () => setActiveStep(step) : null}>
        <StepNumber Container={FlexContainers.FlexRowCenter}>
          <Paragraph2>{step}</Paragraph2>
        </StepNumber>

        <WrapperContainer
          Container={FlexContainers.FlexRowBetween}
          alignItems="center"
          width="100%">
          <StepTitle>{t(title)}</StepTitle>

          {!isDisabled && <SVG.ArrowRightIcon color={colors.RAISIN_100} />}
        </WrapperContainer>
      </StepHeader>

      <StepContentWrapper Container={FlexContainers.FlexRowStart} gap={18}>
        <Line />

        <WrapperContainer
          Container={FlexContainers.FlexColumn}
          width="100%"
          height="100%"
          pt={8}
          pb={24}>
          {!isDisabled ? DividerContent : null}
        </WrapperContainer>
      </StepContentWrapper>
    </StepStyled>
  );
};

Step.propTypes = {
  step: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  DividerContent: PropTypes.node,
  isActive: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool,
  setActiveStep: PropTypes.func
};
